import ApiService from '../ApiService';
const { REACT_APP_REST_ENDPOINT } = process.env;

export default class EsamiService {
  
  static getEsamiByIdCorso = (idCorso) => {
    return new Promise((resolve, reject) => { 
      let url = `${REACT_APP_REST_ENDPOINT}/esami/findByIdCorso`;
      return ApiService.postRequest(resolve, reject, url, idCorso);
    })
  };

  static getEsamiByIdClasse = (idClasse) => {
    return new Promise((resolve, reject) => { 
      let url = `${REACT_APP_REST_ENDPOINT}/esami/findByIdClasse`;
      return ApiService.postRequest(resolve, reject, url, idClasse);
    })
  };

  static getAllEsamiByIdClasse = (idClasse) => {
    return new Promise((resolve, reject) => { 
      let url = `${REACT_APP_REST_ENDPOINT}/esami/getAllEsamiByClasse`;
      return ApiService.postRequest(resolve, reject, url, idClasse);
    })
  };

  static getEsamiByClasseAndByToken = (idClasse) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/esami/getEsamiByClasseForUser`;
      ApiService.postRequest(resolve, reject, url, idClasse);
    });
  };

  static getEsameById = (id) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/esami/show`;
      ApiService.getRequest(resolve, reject, url, id);
    });
  };

  static createEsame = (data) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/esami/create`;
      ApiService.postRequest(resolve, reject, url, data);
    });
  };

  static deleteEsame = (id) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/esami/delete`;
      ApiService.delete(resolve, reject, url, id);
    });
  };

  static updateEsame = (data) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/esami/update`;
      ApiService.putRequest(resolve, reject, url, data);
    });
  };

  static getDocentiAbilitatiPerCorso = (data) => {
    return new Promise((resolve, reject) => { 
      let url = `${REACT_APP_REST_ENDPOINT}/esami/getDocentiAbilitatiPerCorso`;
      return ApiService.postRequest(resolve, reject, url, data);
    })
  };
}
